import { Flex } from "styles/utility-components";

import AccountBriefingButton from "components/actions/GetAccountBriefingButton";
import EmptyState from "components/ui/empty_state/EmptyState";
import { BuyerDetails } from "lib/types/models";

type CustomBriefingTabProps = {
  buyer: BuyerDetails;
};

export default function CustomBriefingTab({ buyer }: CustomBriefingTabProps): JSX.Element {
  return (
    <Flex justifyContent="center" alignItems="center">
      <EmptyState
        size="large"
        type="noDocuments"
        heading="Create custom account briefing"
        description="Analyse all Stotles data on this company to create a custom briefing for your requirements"
        action={
          <AccountBriefingButton buyer={buyer} contextName="Custom Briefing tab" type="primary" />
        }
      />
    </Flex>
  );
}
